<template>
  <div class="fondo-login">
    <v-container style="padding: 0;">
      <div style="display: flex;justify-content: center;align-items: center;height: 100vh;">
        <v-card class="login-card" style="padding: 1rem;">
          <v-card-title class="white--text" style="display: flex; justify-content: center;">
            <span class="headline" style="color: #636363; font-size: 1.8rem !important;">Bienvenido</span>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="iniciarSesion">
              <v-text-field v-model="username" label="Username" prepend-icon="mdi-account" required
                class="white--text"></v-text-field>
              <v-text-field v-model="password" label="Password" type="password" prepend-icon="mdi-lock" required
                class="white--text"></v-text-field>
              <v-btn type="submit" color="primary" block>Ingreso</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </div>
      <v-dialog v-model="dialogLoader" persistent width="300"
        style="padding: 1rem;overflow: hidden !important;background: white !important;">
        <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
      </v-dialog>
    </v-container>
  </div>
</template>
<style scoped>
.fondo-login {
  width: 100%;
  background-color: #094698;
  background-image: url("../../../assets/login_geo.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
}

.theme--light.v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.v-application .white--text {
  color: rgba(0, 0, 0, 0.6) !important;
  caret-color: rgba(0, 0, 0, 0.6) !important;
}

.theme--light.v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}

.theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: rgba(0, 0, 0, 0.42) !important;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  color: rgba(0, 0, 0, 0.87) !important;
}

.fill-height {
  height: 100vh;
}

.login-card {
  background: white !important;
  color: rgb(0, 0, 0) !important;
}

.v-text-field__slot input {
  color: white !important;
}

.v-text-field__details {
  color: white !important;
}

.v-icon {
  color: white !important;
}

::v-deep .v-dialog {
  display: flex;
  justify-content: center;
  box-shadow: none;
  overflow-y: hidden !important;
}
</style>
<script>
import Swal from "sweetalert2";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
  data() {
    return {
      dialogLoader: false,
      username: '',
      password: '',
      contra: "",
    };
  },
  methods: {
    login() {
      if (this.username == "cnsr123" && this.password == "cnsr123" || this.username == "gerencia" && this.password == "gerencia") {
        sessionStorage.setItem("usuario", this.username);
        this.$router.push("/geoMenuJaen");
      } else {
        Swal.fire({
          title: "¡Error!",
          text: "Los datos ingresados no son válidos",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        console.log('Username and Password are required');
      }
    },
    async iniciarSesion() {
      this.dialogLoader = true;
      this.dialog = true;
      this.$router.push("/geoMenuJaen");
      try {
        // Aquí iría la lógica para autenticar al usuario (e.g., llamada a una API)
        const response = await axios.post(RUTA_SERVIDOR + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        });
        this.auth = "Bearer " + response.data.access;
        const res = await axios.get(RUTA_API + "/usuario/?search=" + this.username, {
          headers: { Authorization: this.auth },
        });
        const user = {
          name: this.username,
        };
        sessionStorage.setItem("keyValue", response.data.access);
        sessionStorage.setItem("dniUsuario", res.data[0].num_doc);
        sessionStorage.setItem("usuario", res.data[0].usuario);
        sessionStorage.setItem("nombre", res.data[0].nombre);
        sessionStorage.setItem("perfil", res.data[0].perfil_id);
        sessionStorage.setItem("url", res.data[0].url);
        sessionStorage.setItem("descripCas", res.data[0].datosCas.descripCas);
        sessionStorage.setItem("codIpress", res.data[0].datosCas.codCas);
        sessionStorage.setItem("urlCas", res.data[0].datosCas.url);
        if (res.data[0].clave == this.password && res.data[0].estadoGeo) {
          this.$router.push("/geoMenuJaen");
          this.dialogLoader = false;
          this.dialog = false;
        } else {
          this.dialogLoader = false;
          this.value = true;
          this.dialog = false;
          Swal.fire({
          title: "¡Error!",
          text: "Los datos ingresados no son válidos",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        }
      } catch (error) {
        this.dialogLoader = false;
        console.error('Error durante el inicio de sesión:', error);
      }
    },
  },

};
</script>